import { useState } from 'react';

import ErrorComponent from '@/components/common/error-component/ErrorComponent';
import { WidgetComponent } from '@/forms/components/widget';
import useEffectOnlyOnUpdate from '@/hooks/useEffectOnlyOnUpdate/useEffectOnlyOnUpdate';

import classes from './TimeInput.module.scss';

const TimeInput = ({
	label,
	name,
	placeholder,
	value,
	readOnly,
	disabled,
	onChange,
	required,
	autoFocus,
	resDataAfterSubmit,
	form,
}: WidgetComponent) => {
	const elId = `id_${name}`;

	const [errorAfterSubmit, setErrorAfterSubmit] = useState<string[] | null>(
		null
	);

	useEffectOnlyOnUpdate(() => {
		if (resDataAfterSubmit) {
			const { errorMessage } = resDataAfterSubmit;
			if (Object.entries(errorMessage).length > 0) {
				// eslint-disable-next-line unicorn/no-lonely-if
				if (errorMessage[name]) setErrorAfterSubmit(errorMessage[name]);
			}
		}
	}, [resDataAfterSubmit]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setErrorAfterSubmit(null);
		onChange(e.target.value);
	};

	return (
		<section
			className={[classes.container, classes[name]].join(' ')}
			data-error={errorAfterSubmit ? true : undefined}
		>
			{label && <label htmlFor={elId}>{label}</label>}
			<input
				form={form}
				autoFocus={autoFocus}
				type='time'
				className={classes.input}
				id={elId}
				onChange={handleChange}
				disabled={disabled}
				readOnly={readOnly}
				required={required}
				defaultValue={!(value instanceof Date) && value ? value : ''}
				placeholder={placeholder}
				name={name}
			/>
			{errorAfterSubmit?.map((i, idx) => {
				return (
					<ErrorComponent key={idx} clazz={classes.error}>
						{`*${i}`}
					</ErrorComponent>
				);
			})}
		</section>
	);
};

export default TimeInput;
